export const IndustrySectorValidation = (formData) => {
    const errors = {};
  
    // Validate each field
    if (!formData.IndustrialSector.trim()) {
      errors.IndustrialSector = ' This field is required';
    } 
   
    return errors;
  };
  
 